export const aciMicrowave = {
    iconName: 'microwave',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    d: 'M21.123 5.34H2.9a.889.889 0 00-.89.889v12.889c0 .49.399.889.89.889h18.222a.889.889 0 00.889-.89V6.23a.889.889 0 00-.89-.89z',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M14.365 8.008H5.657a.98.98 0 00-.98.98v7.374c0 .54.44.98.98.98h8.708a.98.98 0 00.98-.98V8.987a.98.98 0 00-.98-.98zM12.678 10.672v4',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M18.679 16.338a.333.333 0 110-.666M18.678 16.338a.333.333 0 100-.666M18.679 12.338a.333.333 0 110-.666M18.68 12.338a.333.333 0 100-.666',
                    stroke: 'currentColor',
                },
            },
        ],
    },
};
